import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import moment from "moment";
import { useSnackbar } from "notistack";

function JobItem(props) {
  const job = props.job;
  const [applied, setApplied] = useState(job.hasApplied);
  const { enqueueSnackbar } = useSnackbar();
  const { isAuthenticated, userType } = useContext(AuthContext);
  const hasExpired = moment(job.apply_before).isBefore(moment());

  const handleJobApply = (id) => {
    axios.post("api/seeker/apply_job", { id }).then((resp) => {
      if (resp.data.status == "success") {
        setApplied(true);
        enqueueSnackbar(resp.data.message, { variant: "success" });
      } else {
        setApplied(false);
        enqueueSnackbar(resp.data.message, { variant: "error" });
      }
    });
  };

  return (
    <div className="twm-jobs-grid-style1">
      <div className="twm-media">
        <Link to={`/jobs/${job.slug}`}>
          {job.photo ? (
            <img src={`/uploads/emp_img/${job.photo}`} alt={job.job_title} />
            // <img src={`/filemanager/${job.clientslug}_${job.clientid}/${job.photo}`} alt={job.job_title} />

          ) : (
            <img src="/default/default_company_logo.jpg" alt={job.job_title} />
          )}
        </Link>
      </div>
      <div className="company_name">
        <Link to={`/company/${job.clientslug}`}>{job.comp_name}</Link>
          {job.job_location != null ? (
            <p className="twm-job-address text-muted">
              <i className="ri-map-pin-line"></i> {job.job_location}
            </p>
          ) : (
            ""
          )}
      </div>
      <div className="twm-mid-content">
        {job.job_title != null ? (
          <Link to={`/jobs/${job.slug}`} className="twm-job-title">
            <h4>{job.job_title}</h4>
          </Link>
        ) : (
          ""
        )}
        
        {job.experience_type == "N" ? (
          <span className="twm-jobs-type text-muted">
            <i className="ri-briefcase-line"></i> No Experience
          </span>
        ) : job.experience_type == "F" ? (
          <span className="twm-jobs-type text-muted">
            <i className="ri-briefcase-line"></i> Fresher
          </span>
        ) : job.experience_type == "E" ? (
          <span className="twm-jobs-type text-muted">
            <i className="ri-briefcase-line">&nbsp;</i>  
            {job.min_exp} 
            {job.min_exp_unit === job.exp_unit 
              ?  `- ${job.max_exp}${job.exp_unit}`
              : ` ${job.min_exp_unit ? job.min_exp_unit : ""} - ${job.max_exp} ${job.exp_unit}`
            }
          </span>
        ) : (
          ""
        )}

        {job.job_type != null ? (
          <span className="twm-job-websites text-muted">
            <i className="ri-building-line"></i> {job.job_type}
          </span>
        ) : (
          ""
        )}

      {job.work_type != null ? (
            <span className="badge bg-info text-white ml-2">{job.work_type}</span>
        ) : (
        ""
      )}

      <span className="twm-job-post-duration">
        <i class="ri-calendar-line"></i> {moment(job.created_at).fromNow()}
      </span>

      <p className="skill_tag">
        {job.jobskills && job.jobskills.length > 0
          ? job.jobskills.slice(0, 4).map((skillitem, idx) => (
              <span key={idx} className="badge badge-secondary ml-1" title={skillitem.title}>
                {skillitem.title.length > 50 
                  ? skillitem.title.substring(0, 50) + '...' 
                  : skillitem.title
                }
              </span>
            ))
          : ""}
      </p>

      </div>
      <div className="twm-right-content">
        <div className="twm-jobs-amount">
          {job.salary_type == "R" ? (
            <div>
              {job.jobcur} {job.minsalary}-{job.maxsalary}{" "}
              <span>/ {job.salary_unit}</span>
            </div>
          ) : job.salary_type == "F" ? (
            <div>
              {job.jobcur} {job.minsalary}
              <span>/ {job.salary_unit}</span>
            </div>
          ) : job.salary_type == "N" ? (
            <div>Negotiable</div>
          ) : (
            ""
          )}
        </div>
        <Link
          to={`/jobs/${job.slug}`}
          className="twm-jobs-browse site-text-primary"
        >
          Browse Job
        </Link>

        {/* {!isAuthenticated ? (
          hasExpired ? (
            <button className="btn btn-danger">Expired</button>
          ) : (
            <Link to={`/login`} className="twm-jobs-browse site-text-primary">
              Apply Now
            </Link>
          )
        ) : null}
        {isAuthenticated && userType == "seeker" ? (
          applied ? (
            <Link
              to="/profile?tab=appliedJobs"
              className="btn btn-outline-success"
            >
              Already Applied
            </Link>
          ) : hasExpired ? (
            <button className="btn btn-danger">Expired</button>
          ) : (
            <a
              href="javascript:;"
              onClick={() => handleJobApply(job.id)}
              className="site-button"
            >
              Apply Now
            </a>
          )
        ) : null} */}
      </div>
    </div>
  );
}

export default JobItem;
